import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {REQUEST_OPTIONS} from '../../app.constants';
import {ApiService} from '../../shared/api';
import {Headers} from '../../shared/utils/headers';

import {PayExec} from './pay-exec.model';

@Injectable()
export class PayExecService {


  constructor(private api: ApiService) {
  }

  public getPayExecs(contractId: number, page = 0): Observable<{ total: number, data: PayExec[] }> {
    return this.api
      .get(`/payroll/api/v1/pay-exec?search=contractID==${contractId}&page=${page}`, REQUEST_OPTIONS.OBSERVE.RESPONSE)
      .pipe(
        map(response => {
          return {
            data: response.body,
            total: parseInt(Headers.get(response.headers, 'X-Total-Count'), 10)
          };
        })
      );
  }
}
